import React, { useEffect, useState, useRef } from "react";
import { SubNavItem, ListItem, UL, Div } from "./styles";
import { GetNav } from "../../StateManagement/Reducers/ScheduleState";
import { useDispatch } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import GetStartedPopup from "../popups/GetStartedPopup.js";
import { getItemHighlightTemplate } from "../setting/HighlightConstants.js";
import { Decrypt_Value } from "../../MiddleWare/EncryptDecrypt/index.js";
import { setGetStarted } from "../../StateManagement/Reducers/GetStartedState.js";

const ScheduleNav = ({ showStepFourIntro, setShowStepFourIntro }) => {
  //------------------------------------------State and Variables Start------------------------------------------//
  const [proavailabilty1, setproavailabilty1] = useState(false);
  const [reposition, setReposition] = useState(false);
  const ProvHighlightRef = useRef(null);
  const calendarHighlightRef = useRef(null);
  const [waitlistPopup, setWaitlistPopup] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const permission = localStorage.getItem("setroles");
  const decryptedPermission = Decrypt_Value(permission, "vozo");

  //------------------------------------------State and Variables End------------------------------------------//
  // ------------------------------- Functions Start--------------------------------------------------------- //

  const setprovabailityNext2 = () => {
    setproavailabilty1(false);
    history.push("/schedule/apptemplate", { showProvPopup: true });
  };

  const handleInputChange = (iconName) => (e) => {
    dispatch(GetNav(iconName));
  };

  const handleIntroNext = () => {
    dispatch(setGetStarted({ fromComponent: true }));
    setShowStepFourIntro(false);
    history.replace({
      pathname: "/schedule/calender",
      search: "?step=6.5",
    });
  };

  const handleIntroBack = () => {
    setShowStepFourIntro(false);
    history.replace({
      pathname: "/patient/patientlist",
      search: "?step=6.3",
    });
  };
  // ------------------------------- Functions End--------------------------------------------------------- //

  useEffect(() => {
    if (proavailabilty1 && ProvHighlightRef.current) {
      ProvHighlightRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      setTimeout(() => {
        setReposition((prev) => !prev);
      }, 500);
    }
  }, [proavailabilty1]);

  useEffect(() => {
    const handleTrigger = () => {
      setproavailabilty1(true);
    };

    window.addEventListener("triggerProviderPopup", handleTrigger);

    return () => {
      window.removeEventListener("triggerProviderPopup", handleTrigger);
    };
  }, []);

  useEffect(() => {
    if (location.state?.Provstarted) {
      setproavailabilty1(true);
      history.replace(location.pathname, {});
    }
  }, [location.state]);

  useEffect(() => {
    const step = new URLSearchParams(location.search).get("step");
    setWaitlistPopup(step === "24" || step === "waitlist1");
  }, [location.search]);

  const handleWaitlistNext = () => {
    setWaitlistPopup(false);
    history.push({
      pathname: "/schedule/calender",
      search: "?step=waitlist2&accountSetupWaitlist=true",
    });
  };

  const handleWaitlistClose = () => {
    setWaitlistPopup(false);
    history.push({
      pathname: "/schedule/calender",
      search: "",
    });
  };

  // ------------------------------- UseEffect End ------------------------------------------------------- //

  return (
    <Div width="100%" paddingLeft="0.86em">
      <UL
        textAlign="left"
        width="100%"
        listStyleType="none"
        padding="0"
        margin="0"
        position="relative"
      >
       
<ListItem
  padding="8px"
  margin="8px 0 0 0"
  onClick={handleInputChange("iconopen")}
  className={waitlistPopup || showStepFourIntro ? "appointment-waitlist-nav-highlight" : ""}
>
  {/* {waitlistPopup && (
    <>
      <div
        style={{
          position: "fixed",
          top: 0, left: 0,
          width: "100%", height: "100%",
           backgroundColor: "rgba(0, 0, 0, 0.55)",
          
          zIndex: 1050,
        }}
        onClick={handleWaitlistClose}
      />
      <div className="appointment-waitlist-calendar-step-one">
        <GetStartedPopup
          title="Access Appointment Waitlist"
          description="Go to Schedule > Calendar menu to access the Appointment Waitlist and add scheduled appointments in to the waitlist"
          currentStep={1}
          totalSteps={8}
          onNext={handleWaitlistNext}
          onClose={handleWaitlistClose}
          width="300px"
        />
      </div>
    </>
  )} */}

  <Popup
    offset={[50, 20]}
    content={
      <GetStartedPopup
        title="Scheduling Appointment"
        description={
          <div>
            <div>
              Go to Schedule {">"} Calendar menu to schedule different
              appointment types like Telehealth & Walk-in to all
              patients.
            </div>{" "}
            <br></br>
            <div>
              Further steps includes adding vitals, services, billing &
              clinical notes.
            </div>
          </div>
        }
        currentStep={4}
        totalSteps={6}
        onNext={handleIntroNext}
        onBack={handleIntroBack}
        onClose={() => setShowStepFourIntro(false)}
        width="320px"
      />
    }
    open={showStepFourIntro}
    className="m-t-10"
    trigger={
      <SubNavItem
        to="/schedule/calender"
        exact
        className={`
          ${(splitLocation[2] === "calender" || location.pathname === "/") ? "active" : ""}
          ${waitlistPopup || showStepFourIntro ? "highlight" : ""}
        `}
                style={waitlistPopup || showStepFourIntro ? { position: "relative", zIndex: 1055, padding: "4px 10px" } : {}}
      >
        Calendar
      </SubNavItem>
    }
    position="left center"
  />
  {showStepFourIntro && (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        zIndex: 10,
      }}
      onClick={() => setShowStepFourIntro(false)}
    />
  )}
      {waitlistPopup && (() => {
            const menuEl = document.querySelector(".appointment-waitlist-nav-highlight");
            const targetRect = menuEl ? menuEl.getBoundingClientRect() : null;

            return (
              <>
                <div
                  style={{
                    position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.4)", zIndex: 1050,
                  }}
                  onClick={handleWaitlistClose}
                />

                <div
                  className="waitlist-icon-popup"
                  style={{
                    position: "fixed",
                    left: targetRect ? `${targetRect.right + 15}px` : "230px",
                    top: targetRect ? `${targetRect.top - 20}px` : "150px",
                    zIndex: 1060,
                    backgroundColor: "#ffffff",
                    borderRadius: "8px",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.18)",
                    padding: "20px 18px 16px 18px",
                    width: "350px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    fontWeight: "normal",
                    fontStyle: "normal",
                  }}
                >
                  {/* Arrow pointing LEFT towards menu item */}
                  <div
                    style={{
                      position: "absolute",
                      left: "-10px",
                      top: "35px",
                      width: 0,
                      height: 0,
                      borderTop: "10px solid transparent",
                      borderBottom: "10px solid transparent",
                      borderRight: "10px solid #ffffff",
                      filter: "drop-shadow(-2px 0px 1px rgba(0,0,0,0.1))",
                    }}
                  />

                  <GetStartedPopup
                    title="Access Appointment Waitlist"
                    description="Go to Schedule > Calendar menu to access the Appointment Waitlist and add scheduled appointments in to the waitlist"
                    currentStep={1}
                    totalSteps={8}
                    onNext={handleWaitlistNext}
                    onClose={handleWaitlistClose}
                    width="320px"
                  />
                </div>
              </>
            );
          })()}
            {/* <SubNavItem
            to="/schedule/calender"
            exact
            className={`
      ${(splitLocation[2] === "calender" || location.pathname === "/") ? "active" : ""}
      ${waitlistPopup ? "highlight" : ""}
    `}
            style={waitlistPopup ? { position: "relative", zIndex: 1055 } : {}}
          >
            Calendar
          </SubNavItem> */}
</ListItem>

        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem to="/schedule/appdashboard" exact>
            Appointment Dashboard
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem to="/schedule/practicedashboard" exact>
            Practice Dashboard
          </SubNavItem>
        </ListItem>

        <Div
          ref={ProvHighlightRef}
          style={
            decryptedPermission.setProviderAvailability
              ? getItemHighlightTemplate(proavailabilty1)
              : {}
          }
        >
          <ListItem
            padding="8px"
            margin="0"
            onClick={handleInputChange("iconopen")}
          >
            {decryptedPermission.setProviderAvailability ? (
              <Popup
                key={reposition}
                 offset={[40, 15]}
                content={
                  <GetStartedPopup
                    title="Setting Provider Availability"
                    description={
                      <div>
                        <div>
                          Go to Schedule {">"} Provider Availability menu to set
                          provider’s availability based on the different
                          categories.
                        </div>
                      </div>
                    }
                    currentStep={1}
                    totalSteps={6}
                    onNext={() => setprovabailityNext2()}
                    onClose={() => setproavailabilty1(false)}
                    width="320px"
                  />
                }
                open={proavailabilty1}
                className="m-t-10"
                trigger={
                  <SubNavItem to="/schedule/apptemplate" exact>
                    Provider Availability
                  </SubNavItem>
                }
                position="left center"
              />
            ) : (
              <SubNavItem to="/schedule/apptemplate" exact>
                Provider Availability
              </SubNavItem>
            )}
          </ListItem>
        </Div>
        {decryptedPermission.setProviderAvailability && proavailabilty1 && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              zIndex: 10,
            }}
            onClick={() => setproavailabilty1(false)}
          />
        )}
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem to="/schedule/billingprofiles" exact>
            Billing Profiles
          </SubNavItem>
        </ListItem>
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem to="/schedule/appprofiles" exact>
            Appointment Profiles
          </SubNavItem>
        </ListItem>

        {/* {(owner_id === null || owner_id === " ") && ( */}
        <ListItem
          padding="8px"
          margin="0"
          onClick={handleInputChange("iconopen")}
        >
          <SubNavItem to="/schedule/auditlog" exact>
            Audit Log
          </SubNavItem>
        </ListItem>
        {/* )} */}
      </UL>
    </Div>
  );
};

export default ScheduleNav;
